import * as cookies from '../lib/cookies'

addEventListener('DOMContentLoaded', () => {
	const cookieBar = document.querySelector('div.cb-bar') as HTMLElement
	if (!cookieBar) {
		return
	}

	const checkboxAnalytic = cookieBar.querySelector('#cb-analytic') as HTMLInputElement
	const checkboxMarketing = cookieBar.querySelector('#cb-marketing') as HTMLInputElement

	// Accept.
	cookieBar.querySelector('#accept')?.addEventListener('click', () => {
		const value = 1 | (checkboxAnalytic.checked ? 2 : 0) | (checkboxMarketing.checked ? 4 : 0)
		cookies.set('c_enabled', value.toString(), 30)
		location.reload()
	})

	// Deny.
	cookieBar.querySelector('#denied')?.addEventListener('click', () => {
		cookies.set('c_enabled', '0', 30)
		cookieBar.remove()
	})

	// Toggle advanced settings.
	cookieBar.querySelector('#advanced-options')?.addEventListener('click', () => {
		cookieBar.classList.toggle('open')
	})
})